import React from 'react'
import { Grid } from '@mui/material'
import { DateRangePicker } from 'rsuite';
import { Controller } from 'react-hook-form';
import { addDays, endOfWeek, startOfMonth, startOfWeek, subDays } from 'rsuite/esm/internals/utils/date';
import Image from './Image';
import Images from 'assets/images';
import "./InputDateRange.css";
import moment from 'moment';

const CalendarIcon = () => {
  return <Image src={Images.icon.calendar} />;
};

const InputHourRange = ({ xs, name, control, label, disabled, rules = {}, required }) => {
  return (
    <>
      <Grid
        item
        xs={xs}
        alignContent="center"
        justifyContent={"center"}
        style={{ width: '100%' }}
      >
        <Controller
          name={name}
          control={control}
          rules={!disabled && {
            ...rules,
            required
          }}
          render={({
            field: { value, onChange },
            fieldState: { error },
          }) => (
            <>
              <DateRangePicker
                value={value}
                onChange={onChange}
                disabled={disabled}
                format="dd/MM/yyyy HH:mm"
                placeholder={label}
                style={{ 
                  width: '100%', 
                  border: '1px solid #041C3F',
                  borderRadius: '8px',
                }}
                cleanable={false}
                caretAs={CalendarIcon}
                ranges={[
                  {
                    label: 'Última hora',
                    value: [ moment().subtract(1, 'hour').toDate(),moment().toDate(),],
                    placement: 'left'
                  },
                  {
                    label: 'Últimas 6 horas',
                    value: [moment().subtract(6, 'hour').toDate(), moment().toDate()],
                    placement: 'left'
                  },
                  {
                    label: 'Últimas 12 horas',
                    value: [moment().subtract(12, 'hour').toDate(), moment().toDate()],
                    placement: 'left'
                  },
                  {
                    label: 'Hoy',
                    value: [moment().startOf('day').toDate(), moment().endOf('day').toDate()],
                    placement: 'left'
                  },
                  {
                    label: 'Ayer',
                    value: [moment().subtract(1, 'day').startOf('day').toDate(), moment().subtract(1, 'day').endOf('day').toDate()],
                    placement: 'left'
                  },
                ]}
              />
            </>
          )}
        />
      </Grid>
    </>
  )
}

export default InputHourRange